import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { clearCookieConsent } from "@/utils/cookieConsent";
const Footer = () => {
  return <footer className="bg-bbz-green/30 pt-12 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="font-playfair font-semibold text-xl mb-4">Bio Beauté Zen</h3>
            <p className="mb-4 text-bbz-text">
              Votre institut de beauté bio proposant des soins naturels et respectueux de votre peau et de
              l'environnement.
            </p>
            <div className="flex items-center space-x-4">
              <a href="https://www.facebook.com/BioBeauteZen" aria-label="Facebook" className="text-bbz-text hover:text-bbz-green">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a href="https://www.instagram.com/biobeautezen_montpellier/" aria-label="Instagram" className="text-bbz-text hover:text-bbz-green">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-playfair font-semibold text-xl mb-4">Liens rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-bbz-text hover:text-bbz-green transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/institut-beaute-bio-montpellier" className="text-bbz-text hover:text-bbz-green transition-colors">
                  Bio Beauté Zen
                </Link>
              </li>
              <li>
                <Link to="/soins-visage-massages-epilations-montpellier" className="text-bbz-text hover:text-bbz-green transition-colors">
                  Carte des soins
                </Link>
              </li>
              <li>
                <Link to="/bon-cadeaux-estheticienne-bio-montpellier" className="text-bbz-text hover:text-bbz-green transition-colors">
                  Bon Cadeau
                </Link>
              </li>
              <li>
                <Link to="/contact-institut-montpellier" className="text-bbz-text hover:text-bbz-green transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-playfair font-semibold text-xl mb-4">Contact</h3>
            <div className="space-y-3">
              <div className="flex items-start">
                <MapPin className="w-5 h-5 mr-2 text-bbz-green mt-0.5" />
                <a href="https://www.google.com/maps/search/?api=1&query=43.59402124660846,3.8899281825552445" target="_blank" rel="noopener noreferrer" className="hover:underline text-bbz-text">1420 Chem. de Moulares, 34070, Montpellier</a>
              </div>

              <div className="flex items-center">
                <Mail className="w-5 h-5 mr-2 text-bbz-green" />
                <a href="mailto:biobeautezen.institut@gmail.com" className="hover:underline text-bbz-text">
                  biobeautezen.institut@gmail.com
                </a>
              </div>
              <div className="flex items-center">
                <Phone className="w-5 h-5 mr-2 text-bbz-green" />
                <a href="tel:+33499538308" className="hover:underline text-bbz-text">
                  04 99 53 83 08 (laissez un message)
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-bbz-green/30 pt-6 text-center text-sm">
          <p>© {new Date().getFullYear()} Bio Beauté Zen - Tous droits réservés</p>
          <p className="mt-2">
            <Link to="/mentions-legales" className="text-bbz-text hover:text-bbz-green transition-colors">
              Mentions légales
            </Link>{" "}
            |{" "}
            <Link to="/politique-confidentialite" className="text-bbz-text hover:text-bbz-green transition-colors">
              Politique de confidentialité
            </Link>{" "}
            |{" "}
            <button 
              onClick={() => clearCookieConsent()} 
              className="text-bbz-text hover:text-bbz-green transition-colors"
            >
              Gérer les cookies
            </button>{" "}
            |{" "}
            <a 
              href="mailto:riviere.bastien.mtp@gmail.com?subject=Demande%20de%20contact%20pour%20la%20cr%C3%A9ation%20d'un%20site%20internet&body=Bonjour%20Bastien,%0D%0A%0D%0AJe%20vous%20contacte%20car%20je%20suis%20int%C3%A9ress%C3%A9(e)%20par%20la%20cr%C3%A9ation%20d'un%20site%20internet.%0D%0A%0D%0AVoici%20les%20d%C3%A9tails%20de%20mon%20projet%20:%0D%0A%0D%0A-%20Nature%20du%20projet%20:%20%0D%0A-%20Besoins%20sp%C3%A9cifiques%20:%20%0D%0A-%20D%C3%A9lais%20souhait%C3%A9s%20:%20%0D%0A%0D%0AJe%20reste%20%C3%A0%20votre%20disposition%20pour%20en%20discuter.%0D%0A%0D%0ACordialement," 
              className="text-bbz-text/70 hover:text-bbz-green transition-colors text-xs"
              title="Contactez-moi pour votre projet web"
            >
              Conçu avec soin par Bastien RIVIERE
            </a>
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;